import React, {FunctionComponent} from "react";
import {FilePreviewerProps} from "../FilePreview";

export const VideoPreview: FunctionComponent<FilePreviewerProps> = (props) => {
    return (
        <video preload='auto' controls={true} width="100%">
            <source src={props.file?.url}/>
        </video>
    );
};